<template lang="pug">
  span(v-if='shouldShow')
    slot
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

const PERMISSION_TYPES = ["briefs", "alerts", "flags", "recognise", "*"];
const PERMISSION_CAN = ["view", "add", "edit", "*"];

const checkPermissionType = (permissions, type) =>
  !!permissions.find(p => p[`can${_.upperFirst(type)}`]);

export default {
  props: {
    type: {
      validator: value => PERMISSION_TYPES.indexOf(value) > -1
    },
    can: {
      validator: value => PERMISSION_CAN.indexOf(value) > -1
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("auth", ["permissions"]),
    shouldShow() {
      if (this.permissions === "*" || this.type === "*") {
        return true;
      }
      return checkPermissionType(
        _.get(this.permissions, this.type, []),
        this.can
      );
    }
  }
};
</script>
